<template>
  <swiper class="firstSwiper" :options="swiperOption" v-if="imgAddress.length>0">
    <swiper-slide class="slide-1" v-for="(item,index) in imgAddress" :key="index">
      <a :href="item.link"><img :src="item.imageUrl" alt /></a>
    </swiper-slide>
    <div class="swiper-pagination" slot="pagination"></div>
  </swiper>
</template>

<script>
// import "swiper/dist/css/swiper.css";
// import axios from 'axios'
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  components: {
    swiper,
    swiperSlide
  },
  mounted() {
    this.axios
      .get("/api/consume/Banner", {
        params: {
          bannerType: 2
        }
      })
      .then(res => {
        // console.log(res.data)
        this.imgAddress = res.data;
      });
  },
  data() {
    return {
      imgAddress: [],
      swiperOption: {
        // effect: "coverflow",
        // slidesPerView: 1,
        // grabCursor: true,
        // coverflowEffect: {
        //   rotate: 5,
        //   stretch: 10,
        //   depth: 20,
        //   modifier: 2,
        //   slideShadows: false,
        //   spaceBetween:20
        // },
        autoplay: true,
        // spaceBetween: 10,
        // slidesOffsetBefore: 25,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable:true,
          type: "custom",
          renderCustom: function(swiper, current, total) {
            const activeColor = "#5db75d";
            const normalColor = "#c1d5ff";
            let color = "";
            let paginationStyle = "";
            let html = "";
            for (let i = 1; i <= total; i++) {
              if (i === current) {
                color = activeColor;
              } else {
                color = normalColor;
              }
              paginationStyle = `margin-bottom:5px;background:${color};opacity:1;margin-right:20px;width:15px;height:15px;border-radius:50%;`;
              html += `<span class="swiper-pagination-bullet" style=${paginationStyle}></span>`;
            }
            return html;
          }
        }
      }
    };
  }
};
</script>

<style>
.firstSwiper {
  height: 408px;
}
.firstSwiper .swiper-container {
  width: 100% !important;
  /* height: 1; */
  /* padding: 50px !important; */
  margin: 0 auto;
  margin-top: 18px;
}
.firstSwiper .swiper-slide {
  /* background-position: 50% !important; */
  background-size: cover !important;
  width: 100% !important;
}
.firstSwiper .swiper-slide img {
  /* width: 660px;
  height: 360px; */
  width: 100%;
  height: auto;
  /* border-radius: 20px; */
}
.firstSwiper .swiper-pagination{
  display: flex;
  justify-content: center;
}
.firstSwiper .swiper-pagination-custom {
  bottom: 15px;
  left: 0;
  width: 100%;
}
/*自定义分页器的样式，这个你自己想要什么样子自己写*/
.firstSwiper .swiper-pagination-customs {
  width: 30px;
  height: 4px;
  display: inline-block;
  background: #000;
  opacity: 0.3;
  margin: 0 5px;
}

.firstSwiper .swiper-pagination span {
  margin-right: 0.3rem !important;
}
/*自定义分页器激活时的样式表现*/
.firstSwiper .swiper-pagination-customs-active {
  opacity: 1;
  background-color: #f78e00;
}
</style>


// WEBPACK FOOTER //
// src/components/swiper/First-swiper.vue